import {
  CLOSE_USER_REPORTS_DIALOG,
  SHOW_NEW_USER_REPORTS_DIALOG,
  UPDATE_DATE_START,
  UPDATE_DATE_END,
  SHOW_ACTIVE_USER_REPORTS_DIALOG,
  CLOSE_RECEIVE_NEWSLETTER_REPORTS_DIALOG,
  SHOW_RECEIVE_NEWSLETTER_REPORTS_DIALOG,
  FETCH_COMMUNITY_REPORTS_SUCCEEDED,
  SELECT_ACTIVE_BUILDING,
  UPDATE_ACTIVE_BUILDING,
  UPDATE_FILTER
} from '../actions/reports'

export const reportsReducer = (state = {}, action) => {
  switch (action.type) {
    case SHOW_NEW_USER_REPORTS_DIALOG:
      return {
        ...state,
        showNewUserReportsDialog: true
      }
    case SHOW_ACTIVE_USER_REPORTS_DIALOG:
      return {
        ...state,
        showActiveUserReportsDialog: true
      }

    case UPDATE_DATE_START:
      return {
        ...state,
        valueStart: action.value,
        nameStart: action.name
      }
    case UPDATE_DATE_END:
      return {
        ...state,
        valueEnd: action.value,
        nameEnd: action.name
      }

    case CLOSE_USER_REPORTS_DIALOG:
      return {
        ...state,
        showNewUserReportsDialog: false,
        showActiveUserReportsDialog: false,
        valueStart: undefined,
        valueEnd: undefined
      }

    case CLOSE_RECEIVE_NEWSLETTER_REPORTS_DIALOG:
      return {
        ...state,
        showReceiveNewsletter: false,
        newsletterBuildingId: undefined
      }

    case FETCH_COMMUNITY_REPORTS_SUCCEEDED:
      return {
        ...state,
        showReceiveNewsletter: false
      }

    case SHOW_RECEIVE_NEWSLETTER_REPORTS_DIALOG:
      return {
        ...state,
        showReceiveNewsletter: true
      }
    case UPDATE_ACTIVE_BUILDING:
      return {
        ...state,
        selectedBuildingId: action.selectedBuildingId
        //   pageOrFilterChanged: true,
        //   pageNumber: 1
      }

    case UPDATE_FILTER:
      return {
        ...state,
        filter: { ...state.filter, [action.filter]: action.value }
        // pageOrFilterChanged: true,
        // pageNumber: 1
      }

    case SELECT_ACTIVE_BUILDING:
      return {
        ...state,
        newsletterBuildingId: action.newsletterBuildingId
      }

    default:
      return {
        ...state,
        newsletterBuildingId: undefined
      }
  }
}

export default reportsReducer



// WEBPACK FOOTER //
// ./src/reducers/reports.js